var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-modal-container',{attrs:{"title":_vm.$t('tokens.title.viewDemands'),"width":"900px"},on:{"close":_vm.back}},[(_vm.value)?_c('tokens-demand-view',{attrs:{"value":_vm.value}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }